export default "__VITE_ASSET__DRxym4Id__"